export var CreateTicketStatus;
(function (CreateTicketStatus) {
    CreateTicketStatus["Error"] = "Error";
    CreateTicketStatus["Success"] = "Success";
    CreateTicketStatus["NoAgentAvailable"] = "NoAgentAvailable";
    CreateTicketStatus["OutOfAttendanceHour"] = "OutOfAttendanceHour";
})(CreateTicketStatus || (CreateTicketStatus = {}));
